/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/phone/sheets/QaPhoneAddSheet.tsx
 * FILE_ID: JOBHUB-QA-PHONE-ADD-SHEET-001
 * PURPOSE: The title-row Plus list. Same four adds as More, without Templates.
 */
import { MobileSheet } from '@quotech/ui'
import { QA_PHONE_CONTROLS } from '../qaPhoneControlInventory'
import { Row } from './QaPhoneMoreSheet'

export function QaPhoneAddSheet({
  open,
  onClose,
  actions,
}: {
  open: boolean
  onClose: () => void
  actions: {
    addArea: () => void
    addChecklist: () => void
    addProduct: () => void
    standardChecks?: () => void
    addRow: () => void
    insertFromLibrary?: () => void
  }
}) {
  return (
    <MobileSheet open={open} onClose={onClose} title="Add">
      <div className="divide-y divide-border py-1">
        {/* Reused from: phone/sheets/QaPhoneMoreSheet.tsx (Row) */}
        <Row id={QA_PHONE_CONTROLS.addArea} testId="qa-phone-add-sheet-area" label="Add location" onClick={actions.addArea} />
        <Row id={QA_PHONE_CONTROLS.addChecklist} testId="qa-phone-add-sheet-checklist" label="Add checklist" onClick={actions.addChecklist} />
        <Row id={QA_PHONE_CONTROLS.addProduct} testId="qa-phone-add-sheet-product" label="Add Product" onClick={actions.addProduct} />
        {actions.standardChecks ? (
          <Row id={QA_PHONE_CONTROLS.standardChecks} testId="qa-phone-add-sheet-standard" label="Standard checks" onClick={actions.standardChecks} />
        ) : null}
        <Row id={QA_PHONE_CONTROLS.addRow} testId="qa-phone-add-sheet-row" label="Add row" onClick={actions.addRow} />
        {actions.insertFromLibrary ? (
          <Row id="qa-phone-insert-library" testId="qa-phone-add-sheet-library" label="Insert from library" onClick={actions.insertFromLibrary} />
        ) : null}
      </div>
    </MobileSheet>
  )
}
